interface TypographyProps {
  variant:
    | 'category'
    | 'categoryPrimary'
    | 'heading'
    | 'heading2'
    | 'heading3'
    | 'heading4'
    | 'description'
    | 'description2'
    | 'categoryDefault';
  children: React.ReactNode;
  className?: string;
  inlineStyle?: object;
  id?: string;
}

const typographyStyles = {
  category: 'text-locale-24 text-primary-600 font-medium',
  categoryPrimary: 'text-locale-20 text-primary-600 font-medium',
  categoryDefault: 'text-locale-20 text-[#000000] font-medium',
  heading: 'text-locale-42 text-[#000000] font-bold tracking-[-1.05px]',
  heading2: 'text-locale-28 text-[#000000] font-bold',
  heading3: 'text-locale-24 text-[#000000] font-semibold',
  heading4: 'text-locale-20 leading-[32px] text-[#000000] font-medium',
  description: 'text-locale-20 text-[#111111] leading-[32px] font-[400] whitespace-pre-line',
  description2: 'text-locale-16 text-[#111111] leading-[28px] font-[400] whitespace-pre-line',
};

const PcTypography = ({ variant, children, className, inlineStyle, id }: TypographyProps) => {
  return (
    <p className={`${typographyStyles[variant]} ${className}`} style={inlineStyle} id={id}>
      {children}
    </p>
  );
};

export default PcTypography;
